import financeKidsV2Service from "@/services/Finance_Kids_V2/FinanceKidsV2Service";
import NotifyMessage from "@/commonFuncion/NotifyMessage";

export default {
    methods:{
        // Hiển thị trên app phụ huynh cho  1 or nhều học sinh
        showListOrderForApp(idKidList,dataSearch,showListForApp) {
            if (idKidList.split(",").map(Number).indexOf(0) === 0) {
                NotifyMessage.leftCornerNotificationWarning("Chưa có học sinh nào được chọn")
            } else {
                this.$confirm(
                    `
            ⚠️ <strong>Bạn có chắc chắn muốn hiện các hóa đơn được chọn không?</strong><br><br>
            Vui lòng kiểm tra kỹ thông tin hóa đơn trước khi thực hiện:<br>
            👉 Bạn muốn tiếp tục?
            `,
                    "Xác nhận thay đổi trạng thái hóa đơn",
                    {
                        confirmButtonText: "Có, Tiếp tục",
                        cancelButtonText: "Không",
                        type: "warning",
                        dangerouslyUseHTMLString: true,
                        closeOnClickModal: false,
                        distinguishCancelAndClose: true,
                    }
                ).then(async () => {
                    showListForApp.date = this.$funcCommon.formatMY(dataSearch.createdYear, dataSearch.month);
                    showListForApp.idKidList = idKidList.split(",").map(Number);
                    showListForApp.collectionTurn = dataSearch.collectionTurn;

                    financeKidsV2Service
                        .showListOrderApp(showListForApp)
                        .then(() => {
                            NotifyMessage.leftCornerNotificationSuccess("Hiển thị thành công!")
                            this.$store.dispatch(
                                "finance2Module/init_kids_data",
                                dataSearch
                            );
                        })
                        .catch((err) => {
                            NotifyMessage.leftCornerNotificationSuccess(err.response.data.message)
                        });
                })
            }
        },

        hiddenListOrderForApp(idKidList,dataSearch,showListForApp) {
            if (idKidList.split(",").map(Number).indexOf(0) === 0) {
                NotifyMessage.leftCornerNotificationWarning("Chưa có học sinh nào được chọn")
            } else {
                this.$confirm(
                    `
            ⚠️ <strong>Bạn có chắc chắn muốn ẩn các hóa đơn được chọn không?</strong><br><br>
            Vui lòng kiểm tra kỹ thông tin hóa đơn trước khi thực hiện:<br>
            👉 Bạn muốn tiếp tục?
            `,
                    "Xác nhận thay đổi trạng thái hóa đơn",
                    {
                        confirmButtonText: "Có, Tiếp tục",
                        cancelButtonText: "Không",
                        type: "warning",
                        dangerouslyUseHTMLString: true,
                        closeOnClickModal: false,
                        distinguishCancelAndClose: true,
                    }
                ).then(async () => {
                    showListForApp.date = this.$funcCommon.formatMY(dataSearch.createdYear, dataSearch.month);
                    showListForApp.idKidList = idKidList.split(",").map(Number);

                    showListForApp.collectionTurn = dataSearch.collectionTurn;

                    financeKidsV2Service
                        .hiddenListOrderForApp(showListForApp)
                        .then(() => {
                            NotifyMessage.leftCornerNotificationSuccess("Hiển thị thành công!")
                            this.$store.dispatch(
                                "finance2Module/init_kids_data",
                                dataSearch
                            );
                        })
                        .catch((err) => {
                            NotifyMessage.leftCornerNotificationSuccess(err.response.data.message)
                        });
                });

            }
        },
    }
}